
import { EditorValidator } from "slickgrid-react";
import Contractor from ".";
import  { ContractorCardFormData , CardFormState} from "./formdata";
import ContractorService from "../../../services/contractor/contractor.service";
import * as React from 'react';
import { SyntheticEvent } from "react";



export default class ContractorCardValidators{
    sender: ContractorCardFormData;
    constructor(s: ContractorCardFormData) {
     // super(sender);
        this.sender = s  
     }

     handleClassificationChange(event: { target: any}) {
      
      const {
        target: { value },
      } = event;
     
      this.sender.setState((state: CardFormState) => ({
        ...state,
        c_data: {...(state.c_data), classifications_array : value },
       // alertError: ""
      }))
      //  
      
    };

    onTradeNameChange(event: { target: any}) {
      this.sender.setState((state: CardFormState) => ({
        ...state,
        c_data: {...(state.c_data), trade_name : event.target.value},
        alertError: ""
      }))
    }

    handleGTUChange(event: { target: any}) {
      
      const {
        target: { value },
      } = event;
     
      this.sender.setState((state: CardFormState) => ({
        ...state,
        c_data: {...(state.c_data), gtu_array : value },
       // alertError: ""
      }))
      //  
      
    };

    handleLabelsChange(event: { target: any}) {
      
      const {
        target: { value },
      } = event;
     
      this.sender.setState((state: CardFormState) => ({
        ...state,
        c_data: {...(state.c_data), labels_array : value },
       // alertError: ""
      }))
      //  
      
    };

    onStateChange(event: { target: any}) {
      this.sender.setState((state: CardFormState) => ({
        ...state,
        c_data: {...(state.c_data), contractor_state : event.target.value},
        alertError: ""
      }))
    }

    onContractorTypeChange(event: { target: any}) {
      this.sender.setState((state: CardFormState) => ({
        ...state,
        c_data: {...(state.c_data), contractor_type : event.target.value},
        alertError: ""
      }))
    }

    onContractorNewMChange(event: { target: any}) {
      this.sender.setState((state: CardFormState) => ({
        ...state,
        c_data: {...(state.c_data), contractor_newmstate : event.target.value},
        alertError: ""
      }))
    }

    onContactdatechange(tmp: Date | null, event: SyntheticEvent<any, Event> | undefined) {

      this.sender.setState((state: CardFormState) => ({
        ...state,
        c_data: {...(state.c_data), contactdate: tmp ==null ? 0 : tmp.getTime() },
        alertError: ""
      }))
    }

    onContractorIISChange(event: { target: any}) {
      this.sender.setState((state: CardFormState) => ({
        ...state,
        c_data: {...(state.c_data), iis_name : event.target.value},
        alertError: ""
      }))
    }

    onContractorGroupsChange(event: { target: any}) {
      
      const {
        target: { value },
      } = event;
     
      this.sender.setState((state: CardFormState) => ({
        ...state,
        c_data: {...(state.c_data), group_names_array : value },
       // alertError: ""
      }))
      //  
      
    };

    onIsPersonChange(event: { target: any}) {
     
      this.sender.setState((state: CardFormState) => ({
        ...state,
        c_data: {...(state.c_data), isperson : event.target.checked ? 1 : 0 },
        alertError: ""
      }))
    }

    onSendmailChange(event: { target: any}) {
     
      this.sender.setState((state: CardFormState) => ({
        ...state,
        c_data: {...(state.c_data), sendmail : event.target.checked ? 1 : 0 },
        alertError: ""
      }))
    }

    onUnsubEmlChange(event: { target: any}) {
     
      this.sender.setState((state: CardFormState) => ({
        ...state,
        c_data: {...(state.c_data), unsub_eml : event.target.checked ? 1 : 0 },
        alertError: ""
      }))
    }

    onUnsubTelChange(event: { target: any}) {
     
      this.sender.setState((state: CardFormState) => ({
        ...state,
        c_data: {...(state.c_data), unsub_tel : event.target.checked ? 1 : 0 },
        alertError: ""
      }))
    }

    

    onShortnamechange(event: { target: any}) {
      this.sender.setState((state: CardFormState) => ({
        ...state,
        c_data: {...(state.c_data), shortname : event.target.value},
        alertError: ""
      }))
      if (event.target.value === null || event.target.value === undefined || !event.target.value.length) {
         this.sender.setState((state: CardFormState) => ({
          ...state,
          input_shortname_state:{helperText: 'To pole jest wymagane', error:true}
        }));
      }else if (event.target.value.length>120) {
        this.sender.setState((state: CardFormState) => ({
          ...state,
          input_shortname_state:{helperText: 'To pole przyjmuje maksymalnie 120 znaków', error:true}
        }));
      }else {
        this.sender.setState((state: CardFormState) => ({
          ...state,
          input_shortname_state:{helperText: '', error:false}
        }));

        if (event.target.value.length>0){
          var id=this.sender.contractor_id
          var name=''
          var shortname=event.target.value
          var nip=''
          
          ContractorService.contractorExist(name, shortname, nip, id).then((response: string | any[]) => {
          
                if ( Array.isArray(response) && response.length >0){
                  var msg: string[]=[]
                  for (const element of response) {
                    var tmp = "Istnieje kontrahent: Nazwa skrócona: " + element.name + ", NIP: " + element.nip+  ", Nazwa: " + element.shortname +  ", Grupa: " + element.group_names
                    msg.push(tmp)
                  }

                
                      this.sender.setState((state: CardFormState) => ({
                        ...state,
                        alertErrorMsg:msg,
                        input_shortname_state:{helperText: 'Podana nazwa już istnieje', error:true}
                      }));

                

                }else{
                  this.sender.setState((state: CardFormState) => ({
                    ...state,
                    alertErrorMsg: [],
                    input_shortname_state:{helperText: '', error:false} 
                  }));
                
                }
          }
          ).catch(
            (error: any) => {
              //this.sender.setState((state: State, props: BasicGridProps) => ({
              //  ...state,
              // alertError: error
          })
      
        }
      }
    }

    onNamechange(event: { target: any}) {
      this.sender.setState((state: CardFormState) => ({
        ...state,
        c_data: {...(state.c_data), name : event.target.value},
        alertError: ""
      }))
      if (event.target.value === null || event.target.value === undefined || !event.target.value.length) {
         this.sender.setState((state: CardFormState) => ({
          ...state,
          input_name_state:{helperText: 'To pole jest wymagane', error:true}
        }));
      }else if (event.target.value.length>255) {
        this.sender.setState((state: CardFormState) => ({
          ...state,
          input_name_state:{helperText: 'To pole przyjmuje maksymalnie 255 znaków', error:true}
        }));
      }else {
        this.sender.setState((state: CardFormState) => ({
          ...state,
          input_name_state:{helperText: '', error:false}
        }));   
        if (event.target.value.length>0){
          var id=this.sender.contractor_id
          var name=event.target.value
          var shortname=''
          var nip=''
          
          ContractorService.contractorExist(name, shortname, nip, id).then((response: string | any[]) => {
          
                if ( Array.isArray(response) && response.length >0){
                  var msg: string[]=[]
                  for (const element of response) {
                    var tmp = "Istnieje kontrahent: Nazwa skrócona: " + element.name + ", NIP: " + element.nip+  ", Nazwa: " + element.shortname +  ", Grupa: " + element.group_names
                    msg.push(tmp)
                  }

                
                      this.sender.setState((state: CardFormState) => ({
                        ...state,
                        alertErrorMsg:msg,
                        input_name_state:{helperText: 'Podana nazwa już istnieje', error:true}
                      }));

                

                }else{
                  this.sender.setState((state: CardFormState) => ({
                    ...state,
                    alertErrorMsg: [],
                    input_name_state:{helperText: '', error:false} 
                  }));
                
                }
          }
          ).catch(
            (error: any) => {
              //this.sender.setState((state: State, props: BasicGridProps) => ({
              //  ...state,
              // alertError: error
          })
      
        }
      }
    }

    onNIPchange(event: { target: any}) {
      
      this.sender.setState((state: CardFormState) => ({
        ...state,
        c_data: {...(state.c_data), nip : event.target.value},
        alertError: ""
      }))

      if (event.target.value.length>100) {
        
        this.sender.setState((state: CardFormState) => ({
          ...state,
          input_nip_state:{helperText: 'To pole przyjmuje maksymalnie 100 znaków', error:true}
        }));
      }else if (/[a-zA-Z]+/.test(event.target.value)){
        this.sender.setState((state: CardFormState) => ({
          ...state,
          input_nip_state:{helperText: 'Numer NIP nie może zawierać liter [a-z A-Z]', error:true}
        }));

      }else {
       
        this.sender.setState((state: CardFormState) => ({
          ...state,
          input_nip_state:{helperText: '', error:false}
        }));

        if (event.target.value.length>0){
          var id=this.sender.contractor_id
          var name=''
          var shortname=''
          var nip=event.target.value
          
          ContractorService.contractorExist(name, shortname, nip, id).then((response: string | any[]) => {
          
                if ( Array.isArray(response) && response.length >0){
                  var msg: string[]=[]
                  for (const element of response) {
                    var tmp = "Istnieje kontrahent: Nazwa skrócona: " + element.name + ", NIP: " + element.nip+  ", Nazwa: " + element.shortname +  ", Grupa: " + element.group_names
                    msg.push(tmp)
                  }

                
                      this.sender.setState((state: CardFormState) => ({
                        ...state,
                        alertErrorMsg:msg,
                        input_nip_state:{helperText: 'Podany NIP już istnieje', error:true}
                      }));

                

                }else{
                  this.sender.setState((state: CardFormState) => ({
                    ...state,
                    alertErrorMsg: [],
                    input_nip_state:{helperText: '', error:false} 
                  }));
                
                }
          }
          ).catch(
            (error: any) => {
              //this.sender.setState((state: State, props: BasicGridProps) => ({
              //  ...state,
              // alertError: error
          })
      
        }
      }

    }

    onPhonechange(event: { target: any}) {
        this.sender.setState((state: CardFormState) => ({
          ...state,
          c_data: {...(state.c_data), phone : event.target.value},
          alertError: ""
        }))

        if (event.target.value.length>100) {
          this.sender.setState((state: CardFormState) => ({
            ...state,
            input_phone_state:{helperText: 'To pole przyjmuje maksymalnie 100 znaków', error:true}
          }));
        }else if (/[a-zA-Z]+/.test(event.target.value)){
          this.sender.setState((state: CardFormState) => ({
            ...state,
            input_phone_state:{helperText: 'Numer telefonu nie może zawierać liter [a-z A-Z]', error:true}
          }));
        }else{
          this.sender.setState((state: CardFormState) => ({
            ...state,
            input_phone_state:{helperText: '', error:false}
          }));
        }
         
    }

    onKRSchange(event: { target: any}) {
      this.sender.setState((state: CardFormState) => ({
        ...state,
        c_data: {...(state.c_data), krs : event.target.value},
        alertError: ""
      }))

      if (event.target.value.length>100) {
        this.sender.setState((state: CardFormState) => ({
          ...state,
          input_krs_state:{helperText: 'To pole przyjmuje maksymalnie 100 znaków', error:true}
        }));
      }else if (/[a-zA-Z]+/.test(event.target.value)){
        this.sender.setState((state: CardFormState) => ({
          ...state,
          input_krs_state:{helperText: 'Numer telefonu nie może zawierać liter [a-z A-Z]', error:true}
        }));
      }else{
        this.sender.setState((state: CardFormState) => ({
          ...state,
          input_krs_state:{helperText: '', error:false}
        }));
      }
       
  }

  onREGONchange(event: { target: any}) {
   this.sender.setState((state: CardFormState) => ({
     ...state,
     c_data: {...(state.c_data), regon : event.target.value},
     alertError: ""
   }))

   if (event.target.value.length>100) {
     this.sender.setState((state: CardFormState) => ({
       ...state,
       input_regon_state:{helperText: 'To pole przyjmuje maksymalnie 100 znaków', error:true}
     }));
   }else if (/[a-zA-Z]+/.test(event.target.value)){
     this.sender.setState((state: CardFormState) => ({
       ...state,
       input_regon_state:{helperText: 'Numer telefonu nie może zawierać liter [a-z A-Z]', error:true}
     }));
   }else{
     this.sender.setState((state: CardFormState) => ({
       ...state,
       input_regon_state:{helperText: '', error:false}
     }));
   }
    
}

    onFaxchange(event: { target: any}) {
      this.sender.setState((state: CardFormState) => ({
        ...state,
        c_data: {...(state.c_data), fax : event.target.value},
        alertError: ""
      }))

      if (event.target.value.length>100) {
        this.sender.setState((state: CardFormState) => ({
          ...state,
          input_fax_state:{helperText: 'To pole przyjmuje maksymalnie 100 znaków', error:true}
        }));
      }else if (/[a-zA-Z]+/.test(event.target.value)){
        this.sender.setState((state: CardFormState) => ({
          ...state,
          input_fax_state:{helperText: 'Numer fax-u nie może zawierać liter [a-z A-Z]', error:true}
        }));
      }else{
        this.sender.setState((state: CardFormState) => ({
          ...state,
          input_fax_state:{helperText: '', error:false}
        }));
      }
       
  }

  onStreetChange(event: { target: any}) {
    this.sender.setState((state: CardFormState) => ({
      ...state,
      c_data: {...(state.c_data), street : event.target.value},
      alertError: ""
    }))

    if (event.target.value.length>100) {

      this.sender.setState((state: CardFormState) => ({
        ...state,
        input_street_state:{helperText: 'To pole przyjmuje maksymalnie 100 znaków', error:true}
      }));

    }
    
    this.sender.setState((state: CardFormState) => ({
      ...state,
      input_street_state:{helperText: '', error:false}
    }));


  }

  
  onCorrStreetChange(event: { target: any}) {
   this.sender.setState((state: CardFormState) => ({
     ...state,
     c_data: {...(state.c_data), cor_street : event.target.value},
     alertError: ""
   }))

   if (event.target.value.length>100) {

     this.sender.setState((state: CardFormState) => ({
       ...state,
       input_cor_street_state:{helperText: 'To pole przyjmuje maksymalnie 100 znaków', error:true}
     }));

   }
   
   this.sender.setState((state: CardFormState) => ({
     ...state,
     input_street_state:{helperText: '', error:false}
   }));


 }

  onCityChange(event: { target: any}) {
    this.sender.setState((state: CardFormState) => ({
      ...state,
      c_data: {...(state.c_data), city : event.target.value},
      alertError: ""
    }))

    if (event.target.value.length>100) {

      this.sender.setState((state: CardFormState) => ({
        ...state,
        input_city_state:{helperText: 'To pole przyjmuje maksymalnie 100 znaków', error:true}
      }));

    }
    
    this.sender.setState((state: CardFormState) => ({
      ...state,
      input_city_state:{helperText: '', error:false}
    }));


  }

  
  onCorrCityChange(event: { target: any}) {
   this.sender.setState((state: CardFormState) => ({
     ...state,
     c_data: {...(state.c_data), cor_city : event.target.value},
     alertError: ""
   }))

   if (event.target.value.length>100) {

     this.sender.setState((state: CardFormState) => ({
       ...state,
       input_cor_city_state:{helperText: 'To pole przyjmuje maksymalnie 100 znaków', error:true}
     }));

   }
   
   this.sender.setState((state: CardFormState) => ({
     ...state,
     input_city_state:{helperText: '', error:false}
   }));


 }

  onCountryChange(event: { target: any}) {
    this.sender.setState((state: CardFormState) => ({
      ...state,
      c_data: {...(state.c_data), country : event.target.value},
      alertError: ""
    }))

    if (event.target.value.length>100) {

      this.sender.setState((state: CardFormState) => ({
        ...state,
        input_country_state:{helperText: 'To pole przyjmuje maksymalnie 100 znaków', error:true}
      }));

    }
    
    this.sender.setState((state: CardFormState) => ({
      ...state,
      input_country_state:{helperText: '', error:false}
    }));


  }

  
  onCorrCountryChange(event: { target: any}) {
   this.sender.setState((state: CardFormState) => ({
     ...state,
     c_data: {...(state.c_data), cor_country : event.target.value},
     alertError: ""
   }))

   if (event.target.value.length>100) {

     this.sender.setState((state: CardFormState) => ({
       ...state,
       input_cor_country_state:{helperText: 'To pole przyjmuje maksymalnie 100 znaków', error:true}
     }));

   }
   
   this.sender.setState((state: CardFormState) => ({
     ...state,
     input_cor_country_state:{helperText: '', error:false}
   }));


 }

  onProvinceChange(event: { target: any}) {
    this.sender.setState((state: CardFormState) => ({
      ...state,
      c_data: {...(state.c_data), province : event.target.value},
      alertError: ""
    }))

    if (event.target.value.length>100) {

      this.sender.setState((state: CardFormState) => ({
        ...state,
        input_province_state:{helperText: 'To pole przyjmuje maksymalnie 100 znaków', error:true}
      }));

    }
    
    this.sender.setState((state: CardFormState) => ({
      ...state,
      input_province_state:{helperText: '', error:false}
    }));


  }

  
  onCorrProvinceChange(event: { target: any}) {
   this.sender.setState((state: CardFormState) => ({
     ...state,
     c_data: {...(state.c_data), cor_province : event.target.value},
     alertError: ""
   }))

   if (event.target.value.length>100) {

     this.sender.setState((state: CardFormState) => ({
       ...state,
       input_cor_province_state:{helperText: 'To pole przyjmuje maksymalnie 100 znaków', error:true}
     }));

   }
   
   this.sender.setState((state: CardFormState) => ({
     ...state,
     input_province_state:{helperText: '', error:false}
   }));


 }

 onWebpageChange(event: { target: any}) {
   this.sender.setState((state: CardFormState) => ({
     ...state,
     c_data: {...(state.c_data), webpage : event.target.value},
     alertError: ""
   }))

   if (event.target.value.length>100) {

     this.sender.setState((state: CardFormState) => ({
       ...state,
       input_webpage_state:{helperText: 'To pole przyjmuje maksymalnie 100 znaków', error:true}
     }));

   }
   
   this.sender.setState((state: CardFormState) => ({
     ...state,
     input_webpage_state:{helperText: '', error:false}
   }));


 }



    onMailchange(event: { target: any}) {
      this.sender.setState((state: CardFormState) => ({
        ...state,
        c_data: {...(state.c_data), mail : event.target.value},
        alertError: ""
      }))

      if (!(event.target.value === null || event.target.value === undefined || !event.target.value.length)) {
        if (event.target.value.length>100) {
          this.sender.setState((state: CardFormState) => ({
            ...state,
            input_mail_state:{helperText: 'To pole przyjmuje maksymalnie 100 znaków', error:true}
          }));
        }else if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,}$/.test(event.target.value)){
          this.sender.setState((state: CardFormState) => ({
            ...state,
            input_mail_state:{helperText: 'Nieprawidłowy format adresu e-mail', error:true}
          }));
        }
      }
      this.sender.setState((state: CardFormState) => ({
        ...state,
        input_mail_state:{helperText: '', error:false}
      }));

    }



    onPostcodechange(event: { target: any}) {
      this.sender.setState((state: CardFormState) => ({
        ...state,
        c_data: {...(state.c_data), postcode : event.target.value},
        alertError: ""
      }))

      if (event.target.value.length>20) {
        this.sender.setState((state: CardFormState) => ({
          ...state,
          input_postcode_state:{helperText: 'To pole przyjmuje maksymalnie 20 znaków', error:true}
        }));
        
      }else if (/[a-zA-Z]+/.test(event.target.value)){
          this.sender.setState((state: CardFormState) => ({
            ...state,
            input_postcode_state:{helperText: 'Kod pocztowy nie może zawierać liter [a-z A-Z]', error:true}
          }));
        }
        this.sender.setState((state: CardFormState) => ({
          ...state,
          input_postcode_state:{helperText: '', error:false}
        }));
    }

    
    onCorrPostcodechange(event: { target: any}) {
      this.sender.setState((state: CardFormState) => ({
        ...state,
        c_data: {...(state.c_data), cor_postcode : event.target.value},
        alertError: ""
      }))

      if (event.target.value.length>20) {
        this.sender.setState((state: CardFormState) => ({
          ...state,
          input_cor_postcode_state:{helperText: 'To pole przyjmuje maksymalnie 20 znaków', error:true}
        }));
        
      }else if (/[a-zA-Z]+/.test(event.target.value)){
          this.sender.setState((state: CardFormState) => ({
            ...state,
            input_cor_postcode_state:{helperText: 'Kod pocztowy nie może zawierać liter [a-z A-Z]', error:true}
          }));
        }
        this.sender.setState((state: CardFormState) => ({
          ...state,
          input_cor_postcode_state:{helperText: '', error:false}
        }));
    }


}